import { Field, Form, useFormikContext } from 'formik';
import React, { useEffect } from 'react';
import { LeavingGuard } from '@components/utils/LeavingGuard';
import { Banner, Fieldset, Input, Loading, Select, useDebounce } from '@fourthwall/components';
import { ConfirmBar } from '../../../../../../modules/ConfirmBar';
import { isInitialApiSecret } from '../../utils/isInitialApiSecret';
const validateKey = (value) => {
    return /^[a-z0-9A-Z]{30,}$/i.test(value);
};
export const SettingsForm = ({ storesOptions, storesWarning, isLoading, isSubmitting, onFetchStores, }) => {
    const settingsFormik = useFormikContext();
    const hasInitialApiSecret = isInitialApiSecret(settingsFormik.values.apiSecret);
    const areKeysValid = validateKey(settingsFormik.values.apiKey) &&
        (hasInitialApiSecret || validateKey(settingsFormik.values.apiSecret));
    const debouncedOnFetchStores = useDebounce(onFetchStores, 500);
    useEffect(() => {
        if (validateKey(settingsFormik.values.apiKey) && validateKey(settingsFormik.values.apiSecret)) {
            debouncedOnFetchStores(settingsFormik.values);
        }
    }, [settingsFormik.values.apiKey, settingsFormik.values.apiSecret]);
    const handleApiKeyValueChange = () => {
        if (hasInitialApiSecret) {
            settingsFormik.setFieldValue('apiSecret', '');
        }
    };
    const storeSelectOptions = areKeysValid ? storesOptions : [];
    return (React.createElement(React.Fragment, null,
        React.createElement(Form, null,
            React.createElement(Fieldset, null,
                React.createElement(Fieldset.Row, null,
                    React.createElement(Fieldset.Item, null,
                        React.createElement(Field, { component: Input, name: "apiKey", label: "API key", onValueChange: handleApiKeyValueChange }))),
                React.createElement(Fieldset.Row, null,
                    React.createElement(Fieldset.Item, null,
                        React.createElement(Field, { component: Input, name: "apiSecret", label: "API Secret" }))),
                storesWarning && (React.createElement(Fieldset.Row, null,
                    React.createElement(Fieldset.Item, null,
                        React.createElement(Banner, { appearance: "warning" }, storesWarning)))),
                React.createElement(Fieldset.Row, null,
                    React.createElement(Fieldset.Item, null,
                        React.createElement(Loading, { isLoading: isLoading, size: "small" },
                            React.createElement(Field, { component: Select, name: "storeId", options: storeSelectOptions, label: "ShipStation store", disabled: !storeSelectOptions.length, displayError: false })))))),
        React.createElement(ConfirmBar, { isLoading: isSubmitting, isOpen: settingsFormik.dirty &&
                areKeysValid &&
                !!settingsFormik.values.storeId &&
                !!storeSelectOptions.length, onConfirm: settingsFormik.handleSubmit, onCancel: settingsFormik.resetForm }),
        React.createElement(LeavingGuard, { when: settingsFormik.dirty, isValid: settingsFormik.isValid, onSave: settingsFormik.submitForm })));
};
